import { render, staticRenderFns } from "./MemberBooking.vue?vue&type=template&id=361f523d&scoped=true"
import script from "./MemberBooking.vue?vue&type=script&lang=js"
export * from "./MemberBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361f523d",
  null
  
)

export default component.exports